module.exports = __webpack_public_path__ + "static/IPhone_App_Wizard_12-8484044805208c956e0ea9c631b4648f.png";